import React, { useRef } from 'react'
import Logo from '../assets/logo.png';
import Logo2 from '../assets/logo2.png';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const OrderInvoice = ({setShowDetail, selectedOrder, userData}) => {
const invoiceRef = useRef();

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  const handleDownloadInvoice = () => {
    const input = invoiceRef.current;
    if (!input) return;
  
    html2canvas(input, { scale: 1, logging: false }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      // const pdf = new jsPDF('p', 'pt', 'a4');
 const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [297, 105]
    });      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  
      let heightLeft = imgHeight;
      let position = 0;
  
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
  
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
  
      pdf.save(`invoice_order_${selectedOrder.id}.pdf`);
    }).catch(err => {
      console.error('Error generating PDF:', err);
    });
  };
  
  
  const handlePrintInvoice = () => {
    // Safely parse order_items and free_items, fallback to empty arrays if invalid or undefined
    const orderItems = selectedOrder.order_items ? JSON.parse(selectedOrder.order_items) : [];
    const freeItems = selectedOrder.free_items ? JSON.parse(selectedOrder.free_items) : [];
  
    const windowContent = `
      <html>
        <head>
          <title>Print Invoice</title>
          <style>
            @page {
              size: 76mm auto;
              margin: 0mm;
            }
  
            html, body {
              width: 76mm;
              padding: 0;
              margin: 0;
              font-family: "Noto Sans Mono", monospace;
              font-size: 11px;
              font-weight: bold;
            }
  
            .receipt {
              width: 74mm;
                  padding: 2px;
              box-sizing: border-box;
            }
  
            .center {
              text-align: center;
            }
  
            .right {
              text-align: right;
            }
  
            table {
              width: 100%;
              border-collapse: collapse;
            }
  
            td, th {
              padding: 1px;
              word-wrap: break-word;
              word-break: break-word;
              vertical-align: top;
              font-size: 10px;
              font-weight: semibold;
                          font-family: "Noto Sans Mono", monospace;
            }
  
  
            .item-name {
              width: 50%;
              white-space: normal;
            }
  
            .line {
              border-top: 1px dashed #000;
              margin: 4px 0;
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="center">
              <img src="${Logo2}" style="height: 40px;" />
   
              <p style="font-size:15px;margin:0px;"><strong>${userData.shop_name}</strong></p>
              <p  style="margin:0px;">${userData.address}, ${userData.city}</p>
            </div>
  
            <div class="line"></div>
  
            <p style="margin-bottom:0px;">Order ID: #${selectedOrder.id}</p>
            <p style="margin-top:0px;">Date: ${formatDateTime(selectedOrder.order_date)}</p>
  
            <div class="line"></div>
  
            <p style="margin-bottom:0px;">Customer Name: #${selectedOrder.user_name}</p>
            <p style="margin-bottom:0px;margin-top:0px;">Mobile No: #${selectedOrder.mobile}</p>
          <p style="margin-top:0px;">Address: ${selectedOrder.address} ${selectedOrder.city} ${selectedOrder.state} ${selectedOrder.pincode}</p>
  
                      <div class="line"></div>
  
            <table>
                <tr>
                  <th>SL</th>
                  <th>Item</th>
                  <th class="right">Qty</th>
                  <th class="right">SP</th>
                  <th class="right">Amt</th>
                </tr>
              <tbody>
                ${orderItems.map((item, index) => {
                  const qty = item.avail_qty ?? item.item_qty;
                  const tiers = JSON.parse(item.sell_price);
                  const matchedPrice = tiers.reduce((acc, tier) => {
                    if (qty >= parseInt(tier.qty)) {
                      return parseFloat(tier.price);
                    }
                    return acc;
                  }, parseFloat(tiers[0].price));
                  const total = matchedPrice * qty;
  
                  return `
                    <tr>
                    <td>${index + 1}</td>
                      <td class="item-name">${item.name} ${item.mrp}/-</td>
                      <td class="right">${qty}</td>
                      <td class="right">${matchedPrice.toFixed(2)}</td>
                      <td class="right">${total.toFixed(2)}</td>
                    </tr>
                  `;
                }).join('')}
  
                ${
                  freeItems.length > 0
                  ? `
                    <tr>
                      <td colspan="4" class="center"><strong>--- Free Items ---</strong></td>
                    </tr>
                    ${freeItems.map(item => {
                      const qty = item.quantity;
                      const item_price = item.item_price;
  
  
                      return `
                        <tr>
                          <td class="item-name">${item.name}</td>
                          <td class="right">${qty}</td>
                          <td class="right">${item_price.toFixed(2)}</td>
                          <td class="right">0.00</td>
                        </tr>
                      `;
                    }).join('')}
                  `
                  : ''
                }
              </tbody>
            </table>
  
  
  <br />

  ${selectedOrder.remark
  ? `<span>Remark: ${selectedOrder.remark}</span><br />`
  : ''}
                        <span>Sub Total: ₹${Math.round(Number(selectedOrder.total_amount))}</span><br />
                        <span>Transport Charges: ₹${Math.round(Number(selectedOrder.charges))}</span>

            <p class="right"><strong>Total: ₹${Math.round(Number(selectedOrder.total_amount) + Number(selectedOrder.charges))}</strong></p>
  
            <div class="line"></div>
  
            <p class="center">Thank you for shopping!</p>
          </div>
  
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `;
  
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };
  

  let subtotalSum = 0;
try {
  const orderItems = JSON.parse(selectedOrder.order_items);

  orderItems.forEach((item) => {
    const tiers = JSON.parse(item.sell_price);
    const qty = item.avail_qty ?? item.item_qty;

    const matchedPrice = tiers.reduce((acc, tier) => {
      if (qty >= parseInt(tier.qty)) {
        return parseFloat(tier.price);
      }
      return acc;
    }, parseFloat(tiers[0].price));

    subtotalSum += matchedPrice * qty;
  });
} catch (e) {
  // console.error("Error calculating subtotal:", e);
}



  return (
    
    <>
    <section className='detail-outer'>
        <div className='detail-inner'>

            <div className='d-md-flex justify-content-between'>
<button className='close-btn mb-2' onClick={() => setShowDetail(false)}>Go Back</button>

            <div className='d-flex justify-content-between'>
<button className='edit-btn mb-2' onClick={handlePrintInvoice}>Print Now</button>&nbsp;&nbsp;
<button className='edit-btn mb-2' onClick={handleDownloadInvoice}>Download Invoice</button></div>
            </div>


<p className='mt-3 fw-bold fs-5'>Order Details</p>

<div className='detail-bill col-md-9 mx-auto' ref={invoiceRef}>

<img src={Logo} className='bill-watermark' alt='watermark' />

<p className='fw-bold my-0'>Order Id: #{selectedOrder.id}</p>
<p className='para-text fw-semibold'>Order Date: {formatDateTime(selectedOrder.order_date)}<br />Order Status: {selectedOrder.order_status}</p>

    <p className='fw-bold my-0'>Seller Details:</p>
<p className='para-text fw-semibold'>{userData.shop_name}<br />{userData.gst_no ? <span>GST No: {userData.gst_no}<br /></span> : ''}Address: {userData.address} {userData.city} {userData.state} {userData.pincode}</p>

<div className='row'>

<div className='col-lg-3 col-md-4 col-sm-5'>
    <p className='fw-bold my-0'>Customer Details:</p>
<p className='para-text fw-semibold'>{selectedOrder.user_name}<br />{selectedOrder.mobile}<br />{selectedOrder.email}</p>
</div>

<div className='col-lg-6 col-md-8 col-sm-7'>
        <p className='fw-bold my-0'>Delivery Address:</p>
        <p className='para-text fw-semibold'>{selectedOrder.address} {selectedOrder.city} {selectedOrder.state} {selectedOrder.pincode}</p>
</div>

</div>


<div className='table-responsive'>
<table className='w-100'>

    <tr className='order-tr'>
        <th className='order-th' style={{flex: '0.4'}}>SNo</th>
        <th className='order-th' style={{flex: '4'}}>Product Details</th>
        <th className='order-th'>MRP</th>
        <th className='order-th'>Sale Price</th>
        <th className='order-th'>Qty</th>
        <th className='order-th'>Avail Qty</th>
      {/* <th className='order-th'>Tax</th> */}
      {/* <th className='order-th'>Discount</th> */}
        <th className='order-th'>SubTotal</th>
    </tr>

{JSON.parse(selectedOrder.order_items).map((item, idx) => {
  const tiers = JSON.parse(item.sell_price);
  const qty = item.item_qty;

  let matchedPrice = tiers.reduce((acc, tier) => {
    if (qty >= parseInt(tier.qty)) {
      return parseFloat(tier.price);
    }
    return acc;
  }, parseFloat(tiers[0].price));

  // const subtotal = matchedPrice * qty;
  // console.log(item.avail_qty);
  
  return (
    <tr key={idx} className='order-tr'>
      <td className='order-td fw-semibold' style={{flex: '0.4'}}>{idx + 1}</td>
      <td className='order-td fw-semibold para-text' style={{flex: '4'}}>
        {item.name}&nbsp;
        <span>({item.brand})</span>
      </td>
      <td className='order-td fw-semibold'>₹{item.mrp}</td>
      <td className='order-td fw-semibold'>₹{matchedPrice.toFixed(2)}</td>
      <td className='order-td fw-semibold'>{qty}</td>
      <td className='order-td fw-semibold'>{item.avail_qty !== undefined && item.avail_qty !== null ? item.avail_qty : qty}</td>
      {/* <td className='order-td fw-semibold text-capitalize'>{item.tax_amount}%</td> */}
      {/* <td className='order-td'>{item.discount_type == 'amount' ? '₹' : ''}{item.discount_amount}{item.discount_type == 'percent' ? '%' : ''}</td> */}
      <td className='order-td fw-semibold'>₹{(matchedPrice * (item.avail_qty ?? qty)).toFixed(2)}</td>
    </tr>
  );
})}
</table> 
</div>


  {selectedOrder.free_items != null ? 
  <>

<div className='table-responsive'>
<table className='w-100'>

    <tr className='order-tr'>
        <th className='order-th' style={{flex: '0.4'}}>SNo</th>
        <th className='order-th' style={{flex: '4'}}>Free Item Details</th>
        <th className='order-th'>MRP</th>
        <th className='order-th'>Sale Price</th>
        <th className='order-th'>Qty</th>
        <th className='order-th'>Total</th>
        <th className='order-th'>SubTotal</th>
    </tr>

  {selectedOrder.free_items && JSON.parse(selectedOrder.free_items).length > 0 ? (
    JSON.parse(selectedOrder.free_items).map((item, idx) => (

            <tr key={idx} className='order-tr'>
                    <td className='order-td fw-semibold' style={{flex: '0.4'}}>
                      {idx + 1}
</td>
      <td className='order-td fw-semibold'style={{flex: '4'}}>
        {item.name}<br />
        <span className='para-text'>{item.brand}</span>
      </td>
      <td className='order-td fw-semibold'>₹{item.item_price.toFixed(2)}</td>
        <td className='order-td fw-semibold'>NA</td>
      <td className='order-td fw-semibold'>{item.quantity}</td>
      <td className='order-td fw-semibold'>₹{item.quantity * item.item_price}</td>
      <td className='order-td fw-semibold'>₹0</td>
    </tr>

    ))
  ) : (
    ''
  )}
</table> 
</div>
  </>
  : ''}

<p className='para-text fw-semibold mt-3'>Payment Mode: {selectedOrder.payment_mode}<br />
{selectedOrder.payment_mode == 'Online Payment' && `Transaction Id: ${selectedOrder.payment_id}`}<br />Payment Status: {selectedOrder.payment_status}<br />
Remark: {selectedOrder.remark || 'NA'}</p>

<p className='para-text fw-semibold text-end'>
    Order Total: {subtotalSum.toFixed(2)}<br />
    {selectedOrder.charges != null &&
    (
      <>
      Transport Charges: {selectedOrder.charges}<br /></>
    )}
  Coupon Applied: <br />
  {selectedOrder.coupon_applied != null ? (
    (() => {
      let coupon;
      try {
        coupon = JSON.parse(selectedOrder.coupon_applied);
      } catch (e) {
        return 'NA';
      }

      return (
        <span>
          {coupon.name} (Code: {coupon.code}) – {coupon.discount_type === 'amount' ? '₹' : ''}{coupon.amount}{coupon.discount_type === 'percent' ? '%' : ''} Off
        </span>
      );
    })()
  ) : (
    'NA'
  )}
</p>


<p className='para-text text-end fw-semibold'>
  Grand Total: ₹{Math.round(
    Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)
  )}
</p>

</div>

{/* detail bill ends */}

        </div>
    </section>

    </>
  )
}

export default OrderInvoice